module.exports = __webpack_public_path__ + "static/media/login-shape-secondary-nick.c550dc69.png";